import { Box, BoxProps } from "@chakra-ui/react";

export function ChevronRight({
  color = "white",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props}>
      <svg
        width="8"
        height="14"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.19324 0.69198C1.45532 0.467341 1.84988 0.497692 2.07452 0.759771L7.07452 6.5931C7.27514 6.82716 7.27514 7.17254 7.07452 7.40659L2.07452 13.2399C1.84988 13.502 1.45532 13.5324 1.19324 13.3077C0.931164 13.0831 0.900813 12.6885 1.12545 12.4264L5.77681 6.99985L1.12545 1.57326C0.900813 1.31118 0.931164 0.916619 1.19324 0.69198Z"
          fill={color}
        />
      </svg>
    </Box>
  );
}
